export default function CloseBtnSVG() {
  return (
    <svg
      width="34"
      height="32"
      viewBox="0 0 34 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Close Button</title>
      <g id="clsoe">
        <g id="Group 2668">
          <g id="Line 92">
            <path
              id="Path 1994"
              d="M6.48675 25.0321C6.48642 24.905 6.51254 24.7791 6.56358 24.6617C6.61462 24.5443 6.68958 24.4378 6.78409 24.3483L25.7058 6.28356C25.7998 6.19367 25.9115 6.12235 26.0344 6.0737C26.1573 6.02504 26.289 6 26.4221 6C26.5552 6 26.6869 6.02504 26.8098 6.0737C26.9327 6.12235 27.0444 6.19367 27.1384 6.28356C27.2326 6.37343 27.3073 6.48014 27.3583 6.59759C27.4093 6.71505 27.4355 6.84094 27.4355 6.96808C27.4355 7.09522 27.4093 7.22111 27.3583 7.33857C27.3073 7.45602 27.2326 7.56273 27.1384 7.6526L8.21674 25.7173C8.07489 25.8526 7.89423 25.9446 7.69759 25.9818C7.50095 26.0191 7.29716 25.9998 7.112 25.9265C6.92683 25.8531 6.7686 25.729 6.65731 25.5698C6.54601 25.4106 6.48666 25.2235 6.48675 25.0321Z"
              fill="#EBEBEB"
            />
          </g>
          <g id="Line 93">
            <path
              id="Path 1995"
              d="M6.4863 6.96744C6.48597 6.84033 6.51208 6.71442 6.56313 6.59703C6.61417 6.47963 6.68912 6.37308 6.78364 6.28356C6.87766 6.19367 6.98932 6.12235 7.11223 6.0737C7.23514 6.02504 7.3669 6 7.49996 6C7.63302 6 7.76477 6.02504 7.88769 6.0737C8.0106 6.12235 8.12226 6.19367 8.21628 6.28356L27.138 24.3483C27.3227 24.5307 27.425 24.7751 27.4228 25.0288C27.4206 25.2826 27.3141 25.5254 27.1263 25.7049C26.9384 25.8844 26.6843 25.9863 26.4185 25.9886C26.1527 25.9909 25.8966 25.8935 25.7053 25.7173L6.78364 7.6526C6.6892 7.56276 6.61431 7.45596 6.56328 7.33837C6.51225 7.22078 6.48609 7.09472 6.4863 6.96744Z"
              fill="#EBEBEB"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
